import validate from "/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45login_45global from "/src/middleware/01.login.global.js";
import _02_45enabled_45global from "/src/middleware/02.enabled.global.js";
import manifest_45route_45rule from "/src/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45login_45global,
  _02_45enabled_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}